import * as tslib_1 from "tslib";
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { NugetType, } from '@models';
import { NugetServiceFactory } from '@pages/packages/shared/nuget.util';
import { CommonNugetService, } from '@services';
var PackageVersionViewMode;
(function (PackageVersionViewMode) {
    PackageVersionViewMode[PackageVersionViewMode["Arguments"] = 0] = "Arguments";
    PackageVersionViewMode[PackageVersionViewMode["ReleaseNotes"] = 1] = "ReleaseNotes";
})(PackageVersionViewMode || (PackageVersionViewMode = {}));
var NugetVersionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetVersionsModalComponent, _super);
    function NugetVersionsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PackageVersionViewMode = PackageVersionViewMode;
        _this.nugetService = _this._injector.get(NugetServiceFactory(_this.context.additionalData.type));
        _this._appState = _this._injector.get(AppStateFacade);
        _this._commonNugetService = _this._injector.get(CommonNugetService);
        _this._isHost = _this._appState.user.loggedInAsHost;
        return _this;
    }
    Object.defineProperty(NugetVersionsModalComponent.prototype, "deletePermission", {
        get: function () {
            if (this._isHost) {
                return '';
            }
            return this.context.additionalData.type === NugetType.Libraries ?
                'Libraries.Delete' :
                'Packages.Delete';
        },
        enumerable: true,
        configurable: true
    });
    NugetVersionsModalComponent.prototype.onClose = function (result) {
        if (result) {
            this._dialogRef.close({
                type: 3 /* Remove */,
            });
        }
        else {
            this._dialogRef.close();
        }
    };
    NugetVersionsModalComponent.prototype.showVersions = function () {
        this.selectedPackageVersion = null;
    };
    NugetVersionsModalComponent.prototype.showInformation = function (packageVersion, mode) {
        this.currentPackageVersionViewMode = mode;
        this.selectedPackageVersion = packageVersion;
    };
    Object.defineProperty(NugetVersionsModalComponent.prototype, "isDownloadEnabled", {
        get: function () {
            return this._commonNugetService.isNugetDownloadEnabled(this.context.additionalData.type);
        },
        enumerable: true,
        configurable: true
    });
    NugetVersionsModalComponent.prototype.downloadLink = function (entry) {
        return this.nugetService.downloadLink(entry);
    };
    return NugetVersionsModalComponent;
}(UiModalComponent));
export { NugetVersionsModalComponent };
